import ConsentItemsList from './ConsentItemsList';

export default ConsentItemsList;
